import { ref } from 'vue';
import { getDataSource } from '@/service/meta-service';

const dataSourceRefobject = ref({});

export const getRefobjectData = async () => {
    dataSourceRefobject.value = await getDataSource('nsi./nsi/user-reference-books-refobject-component/select/get');
    dataSourceRefobject.value = dataSourceRefobject.value.data?.map(object => ({
        kod_refobject: object.kod_refobject,
        description: object.description,
    }));
};

export const metaRefbook = {
    keyExpr: 'kod_refbook',
    columns: [
        {
            name: 'kod_refbook',
            caption: 'id',
            dataField: 'kod_refbook',
            allowEditing: false,
            index: 1,
            visible: false,
        },
        {
            name: 'name',
            caption: 'Наименование',
            dataField: 'name',
            allowEditing: true,
            index: 2,
            visible: true,
        },
        {
            name: 'pr_byt',
            caption: 'Тип',
            dataField: 'pr_byt',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'pr_byt_text',
            },
            component: {
                path: 'components/ai-grid-ro/ai-grid-ro.vue',
                text: 'text',
                meta: {
                    keyExpr: 'pr_byt',
                    columns: [
                        { caption: 'id', visible: false, dataField: 'pr_byt' },
                        {
                            caption: 'Признак быта',
                            visible: true,
                            dataField: 'text',
                        },
                    ],
                    api: { select: 'nsi./nsi/users-reference-books/select/get' },
                },
                args: { meta_args: { select: 'nsi.get_pr_byt' } },
            },
            index: 3,
            visible: true,
        },
        {
            name: 'dat_del',
            caption: 'Архив',
            dataField: 'dat_del',
            dataType: 'boolean',
            allowEditing: true,
            index: 4,
            visible: true,
            calculateDisplayValue: (rowData) => !!rowData.dat_del,
        },
        {
            name: 'kod_refobject',
            caption: 'Объекты',
            dataField: 'kod_refobject',
            allowEditing: true,
            value: '123',
            editor: {
                type: 'ai-drop-down',
                text: 'description',
                dataType: 'array',
            },
            component: {
                path: 'views/nsi/user-reference-books/objects-custom-grid-ro.vue',
                id: 'kod_refobject',
                text: 'description',
                meta: {
                    keyExpr: 'kod_refobject',
                    valueExpr: 'description',
                    selectionMode: 'multiple',
                    allowSelectAll: true,
                    columns: [
                        {
                            name: 'kod_refobject',
                            caption: 'kod_refobject',
                            dataField: 'kod_refobject',
                            width: 150,
                            index: 1,
                            visible: false,
                        },
                        {
                            name: 'description',
                            caption: 'Объект',
                            dataField: 'description',
                            width: 250,
                            index: 5,
                            visible: true,
                        },
                    ],
                    api: {
                        select: 'nsi./nsi/user-reference-books-refobject-component/select/get',
                    },
                },
            },
            index: 5,
            visible: true,
        },
    ],
    api: {
        select: 'nsi./nsi/user-reference-books-component/select/get',
        save: 'nsi./nsi/user-reference-books-component/save/set',
    },
    viewId: 'user-reference-books-component',
};

export const metaRefcode = {
    keyExpr: 'kod_refcode',
    columns: [
        {
            name: 'kod_refcode',
            caption: 'id',
            dataField: 'kod_refcode',
            allowEditing: true,
            index: 1,
            visible: false,
        },
        {
            name: 'num',
            caption: 'Номер',
            dataField: 'num',
            allowEditing: true,
            index: 2,
            visible: true,
        },
        {
            name: 'name',
            caption: 'Название',
            dataField: 'name',
            allowEditing: true,
            width: 600,
            index: 3,
            visible: true,
        },
        {
            name: 'dat_del',
            caption: 'Архив',
            dataField: 'dat_del',
            dataType: 'boolean',
            allowEditing: true,
            index: 4,
            visible: true,
            calculateDisplayValue: (rowData) => !!rowData.dat_del,
        },
    ],
    api: {
        select: 'nsi./nsi/user-reference-books-refcode-component/select/get',
        save: 'nsi./nsi/user-reference-books-refcode-component/save/set',
    },
    viewId: 'user-reference-books-refcode-component',
};
